import { MinzeElement, Attrs } from 'minze'

export interface LvcChevronUpIcon {
  width?: number
  height?: number
}

export class LvcChevronUpIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 24],
    ['height', 24],
  ]

  html =
    () => `<svg width="${this.width ?? '24'}" height="${this.height ?? '24'}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.97394 17.8503C1.50425 17.5598 1.35902 16.9435 1.64955 16.4738C2.32437 15.3829 4.39108 12.9383 6.28233 10.8318C7.24218 9.76269 8.18428 8.75037 8.92263 8.00109C9.28995 7.62833 9.61799 7.3093 9.87772 7.07851C10.0054 6.96509 10.1342 6.85708 10.2531 6.77187C10.3112 6.73017 10.3879 6.67873 10.475 6.6336L10.4768 6.63268C10.531 6.60454 10.7328 6.49986 11 6.49986C11.2852 6.49986 11.5 6.62058 11.55 6.64862C11.5515 6.6495 11.5529 6.65028 11.5541 6.65097C11.6402 6.699 11.717 6.75356 11.7757 6.79797C11.8962 6.88915 12.0303 7.00606 12.1661 7.13095C12.4422 7.3848 12.7958 7.73691 13.1939 8.14693C13.9937 8.97041 15.0175 10.0731 16.0497 11.1991C16.8996 12.1263 17.7488 13.0621 18.4897 13.8785C19.5714 15.0704 20.4223 16.0079 20.7071 16.2928C21.0976 16.6833 21.0976 17.3164 20.7071 17.707C20.3166 18.0975 19.6834 18.0975 19.2929 17.707C18.9764 17.3905 18.0512 16.3713 16.9169 15.1216C16.1875 14.318 15.3715 13.4192 14.5753 12.5506C13.545 11.4266 12.5376 10.3418 11.7592 9.5403C11.4599 9.23212 11.2009 8.97244 10.991 8.7712C10.8112 8.94062 10.5947 9.15367 10.3472 9.40488C9.63822 10.1244 8.71853 11.112 7.77053 12.1679C5.84606 14.3114 3.91277 16.6169 3.35045 17.5259C3.05991 17.9956 2.44363 18.1408 1.97394 17.8503Z" fill="#1E007D"/>
  </svg>`

  css = () => `
    :host {
      width: ${this.width ?? '24'}px;
      height: ${this.height ?? '24'}px;
    }
    
  `
}
